import { useState } from 'react'
import { useAlert } from 'react-alert'
import { useParams } from 'react-router-dom'
import { uploadFilePhone } from '../../../main/usecases/Import-files'

import * as S from './styles'

const PhoneImport = () => {
  const [fileName, setFileName] = useState<string>()
  const alert = useAlert()
  const { cdBloco, cdPsicologo } =
    useParams<{ cdBloco: string; cdPsicologo: string }>()

  const handleSave = (
    file: string | ArrayBuffer | null,
    name: string,
    size: number
  ) => {
    try {
      if (size > 5000000) {
        alert.show('Arquivo maior que 5mb', {
          type: 'error',
          timeout: 4000
        })
      } else {
        uploadFilePhone(cdPsicologo, cdBloco).update([
          { descricao: name, path: file }
        ])
      }

      alert.show('Foto anexada com sucesso', {
        type: 'success',
        timeout: 4000
      })
    } catch (error) {
      alert.show('Erro em anexar o arquivo', {
        type: 'error',
        timeout: 4000
      })
    }
  }
  return (
    <S.Wrapper>
      <input
        id="file"
        className="inputfile"
        type="file"
        capture="user"
        accept="image/*"
        onChange={(e) => {
          setFileName(
            !!e?.target?.files && e?.target?.files[0].name
              ? e.target.files[0].name
              : 'Escolha um arquivo'
          )
          const reader = new FileReader()
          const file = (!!e?.target?.files && e?.target?.files[0]) || null
          if (file) {
            reader.readAsDataURL(file)
            reader.onload = () => {
              handleSave(
                reader.result,
                !!e?.target?.files && e?.target?.files[0].name
                  ? e.target.files[0].name
                  : '',
                !!e?.target?.files && e?.target?.files[0].size
                  ? e.target.files[0].size
                  : 0
              )
            }

            reader.onerror = (error) => {
              console.error('Error: ', error)
            }
          }
        }}
      ></input>
      <label htmlFor="file">
        {fileName ||
          'Clique para abrir a câmera e tirar uma foto do documento que deseja anexar'}
      </label>
    </S.Wrapper>
  )
}
export default PhoneImport
